import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '..';
import { IconContext } from '@talismn/web-icons/utils';
const Badge = (props) => (_jsx(Text.BodySmall, { as: "div", ...props, css: theme => [
        {
            color: props.contentColor ?? theme.color.onError,
            display: 'inline-block',
            borderRadius: theme.shape.full,
            minWidth: '1.6em',
            lineHeight: '1em',
            padding: '0.3em',
            backgroundColor: theme.color.error,
            textAlign: 'center',
            svg: { display: 'block' },
        },
        props.children === undefined && { minWidth: 'revert', width: '0.8rem', height: '0.8rem' },
    ], style: { backgroundColor: props.containerColor }, children: _jsx(IconContext.Provider, { value: { size: '1em' }, children: props.children }) }));
export const BadgedBox = ({ overlap = 'rectangular', ...props }) => {
    return (_jsxs("div", { css: {
            position: 'relative',
            // Trick to make parent height equal to child
            display: 'inline-flex',
        }, children: [props.children, _jsx("div", { css: [
                    {
                        position: 'absolute',
                        transform: 'scale(1) translate(50%, -50%)',
                        transformOrigin: '100% 0% 0px',
                    },
                    overlap === 'rectangular'
                        ? {
                            top: 0,
                            right: 0,
                        }
                        : {
                            top: '14%',
                            right: '14%',
                        },
                ], children: props.badge })] }));
};
export default Badge;
//# sourceMappingURL=Badge.js.map